import React from "react";

import "./empty.scoped.scss";

const Empty = ({ title }) => {
    return <div className="empty">{title}</div>;
};

export default Empty;
